
const apiConfig = {
                       baseURL: "https://api.dpworld.online",
                    //  baseURL: "http://localhost:5000",
                  };

export default apiConfig;